<template>
	<m-main-layout v-if="formData">
		<el-form :model="formData" ref="form" label-width="130px" :rules="rules">
			<el-row :gutter="20">
				<el-col :span="8">
					<el-form-item label="名称" prop="title">
						<el-input v-model="formData.title" style="width: 250px;"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="16">
					<el-form-item label="用户类型" prop="user_type">
						<type-select v-model="formData.user_type" :options="[{name:'货主',id:'hz'},{name:'供应商',id:'gys'}]" style="width: 250px" placeholder="请先选择用户类型"></type-select>
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<el-form-item label="顶部图片" prop="head_img">
						<head-img-upload v-model="formData.head_img" :img="formData.head_img ? $config.assetsUrl + formData.head_img : ''" ></head-img-upload>
					</el-form-item>
				</el-col>
				<template v-if="formData.user_type">
					<template v-if="formData.user_type === 'hz'">
						<el-col :span="8">
							<el-form-item label="标讯置顶数量" prop="bids_top_count" :rules="[{required:true,message:'请填写数量'},{pattern:$regexp.integer,message: '必须是 > 0 的整数'}]">
								<el-input v-model="formData.bids_top_count" style="width: 250px;"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="微信推广次数" prop="wxtk_count" :rules="[{required:true,message:'请填写数量'},{pattern:$regexp.integer,message: '必须是 > 0 的整数'}]">
								<el-input v-model="formData.wxtk_count" style="width: 250px;"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="供应商解锁次数" prop="gys_count" :rules="[{required:true,message:'请填写数量'},{pattern:$regexp.integer,message: '必须是 > 0 的整数'}]">
								<el-input v-model="formData.gys_count" style="width: 250px;"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="精准推送供应商" prop="is_jztsgys">
								<el-switch
									v-model="formData.is_jztsgys"
									active-color="#13ce66"
									:active-value="1"
									:inactive-value="0"
									active-text="是"
									inactive-text="否">
								</el-switch>
							</el-form-item>
						</el-col>
						<el-col :span="16">
							<el-form-item label="一键下载供应商" prop="yjxz">
								<el-switch
									v-model="formData.yjxz"
									active-color="#13ce66"
									:active-value="1"
									:inactive-value="0"
									active-text="是"
									inactive-text="否">
								</el-switch>
							</el-form-item>
						</el-col>
					</template>
					<template v-if="formData.user_type === 'gys'">
						<el-col :span="8">
							<el-form-item label="标讯解锁次数" prop="bids_count" :rules="[{required:true,message:'请填写数量'},{pattern:$regexp.integer,message: '必须是 > 0 的整数'}]">
								<el-input v-model="formData.bids_count" style="width: 250px;"></el-input>
								填0为无限制
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="轮番广告时长" prop="bids_count" :rules="[{required:true,message:'请填写数量'},{pattern:$regexp.integer,message: '必须是 > 0 的整数'}]">
								<el-input v-model="formData.banner_time" style="width: 250px;">
									<template slot="append">年</template>
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="1V1客服" prop="is_ovo">
								<el-switch
									v-model="formData.is_ovo"
									active-color="#13ce66"
									:active-value="1"
									:inactive-value="0"
									active-text="是"
									inactive-text="否">
								</el-switch>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="推送标讯" prop="is_jzts">
								<el-switch
									v-model="formData.is_jzts"
									active-color="#13ce66"
									:active-value="1"
									:inactive-value="0"
									active-text="是"
									inactive-text="否">
								</el-switch>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="入住供应商池" prop="is_rzgysc">
								<el-switch
									v-model="formData.is_rzgysc"
									active-color="#13ce66"
									:active-value="1"
									:inactive-value="0"
									active-text="是"
									inactive-text="否">
								</el-switch>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="主页展示/推荐" prop="is_sytj">
								<el-switch
									v-model="formData.is_sytj"
									active-color="#13ce66"
									:active-value="1"
									:inactive-value="0"
									active-text="是"
									inactive-text="否">
								</el-switch>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="在线投标报名" prop="is_zxtb">
								<el-switch
									v-model="formData.is_zxtb"
									active-color="#13ce66"
									:active-value="1"
									:inactive-value="0"
									active-text="是"
									inactive-text="否">
								</el-switch>
							</el-form-item>
						</el-col>
					</template>
					<el-col :span="8">
						<el-form-item label="时长" prop="to_time">
							<el-input v-model="formData.to_time" style="width: 200px;"></el-input>
							<price-time-select class="margin-left" v-model="formData.time_type" style="width: 90px;"></price-time-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="原价" prop="old_price">
							<el-input v-model="formData.old_price" style="width: 250px;"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="现价" prop="price">
							<el-input v-model="formData.price" style="width: 250px;"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="排序" prop="sort">
							<el-input v-model="formData.sort" style="width: 250px;"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="描述" prop="des" class="no-line-height">
							<vue-ueditor-wrap v-model="formData.des" :config="config" :editor-id="editorId"></vue-ueditor-wrap>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="状态">
							<el-switch
								v-model="formData.state"
								active-color="#13ce66"
								:active-value="1"
								:inactive-value="0"
								active-text="可用"
								inactive-text="禁用">
							</el-switch>
						</el-form-item>
					</el-col>
				</template>
			</el-row>
			<el-form-item>
				<el-button @click="$router.back()">返回</el-button>
				<el-button type="primary" @click="submitForm" :disabled="!formData.user_type">保存</el-button>
			</el-form-item>
		</el-form>
	</m-main-layout>
</template>

<script>
export default {
	name: "GoodsSpecEdit",
	data() {
		return {
			formData: {
				id: '',
				title: '',
				user_type: '',
				head_img: '',
				to_time: '',
				time_type: '',
				old_price: '',
				price: '',
				des: '',
				bids_count: '',
				is_jzts: 0,
				is_rzgysc: 0,
				is_sytj: 0,
				is_zxtb: 0,
				banner_time: '',
				is_ovo: 0,
				state: 1,
				sort: '',
				bids_top_count: '',
				wxtk_count: '',
				gys_count: '',
				yjxz: 1,
				is_jztsgys: 0
			},
			rules: {
				title:[{required:true,message:'请输入名称'}],
				user_type:[{required:true,message:'请选择用户类型'}],
				price:[{required:true,message:'请填写价格'},{pattern:this.$regexp.money,message: '请输入正确的价格'}],
				old_price:[{pattern:this.$regexp.money,message: '请输入正确的价格'}],
				to_time:[{required:true,message:'请填写时长'},{pattern:this.$regexp.integer,message: '时长必须是 > 0 的整数'}],
				des:[{required:true,message:'描述必填'}],
				sort:[{required:true,message:'排序必填'}],
				state:[{required:true,message:'状态必选'}],
				head_img:[{required:true,message:'图片必传'}],
			},

			config: {
				// 编辑器不自动被内容撑高
				autoHeightEnabled: false,
				autoFloatEnabled: false,
				// 初始容器高度
				initialFrameHeight: 240,
				// 初始容器宽度
				initialFrameWidth: '100%',
				// 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
				serverUrl: `${this.$config.editUrl}`,
				// UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
				UEDITOR_HOME_URL: '/ueditor/'
			}
		};
	},
	created() {
		this.formData.id = this.$route.query.id ? this.$route.query.id : 0;
	},
	mounted() {
		if (this.formData.id !== 0) {
			this.getDetail();
		}
	},
	methods: {
		submitForm() {
			let _this = this;
			this.$refs['form'].validate((valid) => {
				if (valid) {
					_this.$http.httpPost({
						url: '/VipPrice/edit',
						datas: _this.formData,
						success: (res) => {
							console.log(res);
							_this.$router.replace({path: '/user/vip'})
						}
					})
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		getDetail() {
			let _this = this;

			_this.$http.httpPost({
				url: '/VipPrice/detail',
				datas: {id: _this.formData.id},
				success: (res) => {
					_this.$set(this, 'formData', res);
				}
			})
		},
	},
	computed: {
		// 计算属性的 getter
		editorId: function () {
			return this.$utils.randomWords();
		}
	}
}
</script>
